/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_LabelInputs */

const en_directory_search_label = /** @type {(inputs: Directory_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a service or a specialist`)
};

const pl_directory_search_label = /** @type {(inputs: Directory_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź usługę lub specjalistę`)
};

/**
* | output |
* | --- |
* | "Find a service or a specialist" |
*
* @param {Directory_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_label = /** @type {((inputs?: Directory_Search_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_label(inputs)
	return en_directory_search_label(inputs)
});